import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as configPHSAction from '../../../../actions/configPHSAction';
import PHSMaster from './PHSMaster';

const mapStateToProps = state => {
    return {
        configPHSState: state.configPHSReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getConfigPHS: () => dispatch(configPHSAction.getConfigPHS()),
        setConfigPHS: (phs) => dispatch(configPHSAction.setConfigPHS(phs)),
        updateConfigPHS: (phs) => dispatch(configPHSAction.updateConfigPHS(phs)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PHSMaster));
